'use strict';

var u = require('universalify').fromCallback;

var path = require('path');

var fs = require('graceful-fs');

var mkdir = require('../mkdirs');

var pathExists = require('../path-exists').pathExists;

function createFile(file, callback) {
  function makeFile() {
    fs.writeFile(file, '', function (err) {
      if (err) return callback(err);
      callback();
    });
  }

  pathExists(file, function (err, fileExists) {
    if (err) return callback(err);
    if (fileExists) return callback();
    var dir = path.dirname(file);
    pathExists(dir, function (err, dirExists) {
      if (err) return callback(err);
      if (dirExists) return makeFile();
      mkdir.mkdirs(dir, function (err) {
        if (err) return callback(err);
        makeFile();
      });
    });
  });
}

function createFileSync(file) {
  if (fs.existsSync(file)) return;
  var dir = path.dirname(file);

  if (!fs.existsSync(dir)) {
    mkdir.mkdirsSync(dir);
  }

  fs.writeFileSync(file, '');
}

module.exports = {
  createFile: u(createFile),
  createFileSync: createFileSync
};